// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3VZ3L","title":"Images45_title__24d2y","images":"Images45_images__3Ltwi"};